import { createStyles, Grid, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Icons, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { useMst } from '../../mobx-models/Root';
import { Discipline } from '../../models/models';
import { WORK_PACKAGE_NAV_TAB_OPTIONS } from '../../utilities/constants';

const useStyles = makeStyles(() =>
  createStyles({
    upArrowSVG: {
      position: 'absolute',
      marginLeft: '25px',
    },
    tabOption: {
      backgroundColor: '#332d2d;',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      paddingLeft: '20px',
      paddingRight: '20px',
      paddingTop: '10px',
      '& .selected': {
        color: '#2AAB3F',
      },
      '& p': {
        color: '#FFFFFF',
        paddingBottom: '20px',
        fontSize: '15px',
        cursor: 'pointer',
      },
    },
    paper: {
      width: '200px',
      backgroundColor: 'transparent',
      marginTop: '-13px',
      marginLeft: '-14px',
    },
  }),
);

interface Props {
  tabValue: number;
  changeTab: (e: React.MouseEvent<HTMLButtonElement>, val: number) => void;
}

const WorkpackageNavTab: React.FC<Props> = ({ tabValue, changeTab }: Props) => {
  const classes = useStyles();
  const [isShow, setIsShow] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { SiteDiscipline } = useMst();
  const isElectrical = SiteDiscipline.disciplineId === Discipline.Electrical;

  return (
    <>
      <Popover
        id={'popover'}
        open={isShow}
        anchorEl={anchorEl}
        onClose={() => {
          setIsShow(!isShow);
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        classes={{ paper: classes.paper }}
      >
        <Grid className={classes.tabOption}>
          {WORK_PACKAGE_NAV_TAB_OPTIONS.map((tab: { value: number; label: string }, i) => {
            return (
              <Typography
                data-testid={`tab-${i}`}
                key={i}
                onClick={e => {
                  setIsShow(!isShow);
                  setAnchorEl(null);
                  changeTab(e, tab.value);
                }}
                className={tabValue === tab.value ? 'selected' : ''}
              >
                {isElectrical && tab.label === 'Work Packages' ? 'Routes' : tab.label}
              </Typography>
            );
          })}
        </Grid>
      </Popover>
      <div>
        <Icons.FolderFeather color="white" />
        <Icons.ChevronUpFeather
          className={classes.upArrowSVG}
          color="white"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            setIsShow(!isShow);
            changeTab(e, -1);
            setAnchorEl(e.currentTarget);
          }}
          data-testid="upArrow"
        />
      </div>
    </>
  );
};

export default observer(WorkpackageNavTab);
